import React, { useState, useEffect } from "react";
import {
  getAPIURL,
  getFormattedDate,
  getUserID,
  getVendorID,
} from "../../../services/helper";
import http from "../../../services/http";
import DataTable from "react-data-table-component";
import { Spinner, Container, Card, Input, Button } from "reactstrap";
import { FaExternalLinkAlt, FaListAlt, FaMoneyBillAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  openViewWithParams,
  openView,
} from "../../../ReduxToolkit/Reducers/viewReducer";

const EndDayReports = () => {
  const api_url = getAPIURL();
  const vendor_id = getVendorID(); // Replace with actual vendor ID retrieval
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dateRange, setDateRange] = useState({ start: "", end: "" });
  const dispatch = useDispatch();

  useEffect(() => {
    fetchEndDayReports();
  }, []);

  const fetchEndDayReports = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      params.append("vendor_id", vendor_id);
      if (dateRange.start) params.append("start_date", dateRange.start);
      if (dateRange.end) params.append("end_date", dateRange.end);

      const { data } = await http.get(
        `${api_url}/reports/end-day?${params.toString()}`
      );
      setData(data);
    } catch (error) {
      console.error("Error fetching end of day reports:", error);
    }
    setLoading(false);
  };

  const columns = [
    {
      name: "Opened At",
      selector: (row) => getFormattedDate(row.opened_at),
      sortable: true,
    },
    {
      name: "Closed At",
      selector: (row) => getFormattedDate(row.closed_at),
      sortable: true,
    },
    { name: "Total Sales", selector: (row) => row.total_sales, sortable: true },
    {
      name: "OrderTotal",
      selector: (row) => row.total_amount,
      sortable: true,
    },
    // { name: "Received", selector: (row) => row.total_paid, sortable: true },
    {
      name: "Discount",
      selector: (row) => row.total_discount,
      sortable: true,
    },
    {
      name: "Tax",
      selector: (row) => row.total_tax,
      sortable: true,
    },
    // {
    //   name: "Actions",
    //   cell: (row) => (
    //     <div className="d-flex gap-2">
    //       <Link
    //         onClick={() =>
    //           dispatch(
    //             openViewWithParams({
    //               view: "reports_eod_summary",
    //               params: { eod_id: row.register_id },
    //             })
    //           )
    //         }
    //         className="btn btn-primary btn-sm"
    //         title="Summary Report"
    //       >
    //         <FaExternalLinkAlt />
    //       </Link>
    //       <Link
    //         onClick={() =>
    //           dispatch(
    //             openViewWithParams({
    //               view: "reports_eod_paytypes",
    //               params: { eod_id: row.register_id },
    //             })
    //           )
    //         }
    //         className="btn btn-success btn-sm"
    //         title="Pay Type Report"
    //       >
    //         <FaMoneyBillAlt />
    //       </Link>
    //     </div>
    //   ),
    // },
  ];

  return (
    <div className="page-body">
      <Container className="mt-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <Button color="primary" onClick={() => dispatch(openView("reports"))}>
            Back
          </Button>
          <h2 className="text-center">End of Day Reports</h2>
          <div></div>
        </div>

        {/* Date Range Filters */}
        <div className="d-flex mb-3">
          <Input
            type="date"
            value={dateRange.start}
            onChange={(e) =>
              setDateRange({ ...dateRange, start: e.target.value })
            }
            className="me-2"
          />
          <Input
            type="date"
            value={dateRange.end}
            onChange={(e) =>
              setDateRange({ ...dateRange, end: e.target.value })
            }
            className="me-2"
          />
          <Button color="primary" onClick={fetchEndDayReports}>
            Filter
          </Button>
        </div>

        {loading ? (
          <div className="text-center">
            <Spinner color="primary" size="lg" />
            <p>Loading Reports...</p>
          </div>
        ) : (
          <Card className="p-3 shadow-sm">
            <DataTable
              columns={columns}
              data={data}
              pagination
              striped
              highlightOnHover
              pointerOnHover
              onRowClicked={(row) =>
                dispatch(
                  openViewWithParams({
                    view: "close_register_summary",
                    params: {
                      register_id: row.register_id,
                      backTo: "reports_eod",
                    },
                  })
                )
              }
            />
          </Card>
        )}
        <div className="mt-3">
          <a
            href="/print/reports/eod"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-info no-print"
          >
            Print
          </a>
        </div>
      </Container>
    </div>
  );
};

export default EndDayReports;
